export default __webpack_public_path__ + "static/media/horizontal-ceiling.8b9021aa.png";